"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _utils = require("../../utils");

var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ThemeProvider = function ThemeProvider(_ref) {
  var themeName = _ref.theme,
      children = _ref.children;
  var theme = (0, _utils.getThemeByName)(themeName);

  if (theme) {
    // Expose the theme as a global variable so people can play with it.
    if (process.browser) {
      window.theme = theme; // Access the window from outside the storybook iframe

      window.parent.window.theme = theme;
    }

    return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
      theme: theme
    }, /*#__PURE__*/_react["default"].createElement(_ThemeContext["default"].Provider, {
      value: theme
    }, children));
  } // eslint-disable-next-line no-console


  return console.error("Invalid prop theme of value \"".concat(themeName, "\" supplied to ThemeProvider"));
};

ThemeProvider.propTypes = {
  theme: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired
};
var _default = ThemeProvider;
exports["default"] = _default;